module.exports = __webpack_public_path__ + "img/Geolocation web Icon - charcoal.a6d23abd.svg";